export class DocumentPropertyCodes {
    static readonly CREATION_DATE = 'creationDate';
    static readonly TYPE = 'type';
    static readonly FLUX = 'flux';
    static readonly ATTACHMENTS = 'attachments';
    static readonly FROM = 'from';
    static readonly TO = 'to';
    static readonly LABEL = 'label';
    static readonly ORIGINAL_DATE = 'originalDate';
}
